import React, { useEffect, useState } from "react";
import Chip from "@mui/material/Chip";

import Producto from "./Producto.js";
import "../App.css";

const Grid = (props) => {
  const [filter_word, set_filter_word] = useState("");
  const [list, set_list] = useState(props.products);

  useEffect(() => {
    set_list(props.products);
  }, [props.filter]);

  const filtrar = (e) => {
    set_filter_word(e);
    if (e === "") {
      set_list(props.products);
    } else {
      const filtered_list = props.products.filter((product) =>
        product.category.toLowerCase().includes(e.toLowerCase())
      );
      set_list(filtered_list);
    }
  };

  return (
    <div>
      <div className="stack_container">
        <div className="testdiv">
          <Chip
            label="Todos"
            style={{
              backgroundColor:
                filter_word === "" ? "rgb(201, 201, 201)" : "white",
            }}
            onClick={() => filtrar("")}
            className="chip"
          />
          {props.filter.map((item) => {
            if (/^[A-Za-z0-9_]/.test(item)) {
              return (
                <Chip
                  key={item}
                  label={item}
                  onClick={() => filtrar(item)}
                  style={{
                    backgroundColor:
                      filter_word === item ? "rgb(201, 201, 201)" : "white",
                  }}
                  className="chip"
                />
              );
            } else {
              return "";
            }
          })}
        </div>
      </div>

      <div className="grid">
        <div className="sub_grid">
          {list.map((item) => {
            return (
              <li key={item.name}>
                <Producto
                  product={item}
                  add={props.add}
                  remove={props.remove}
                  modal_beneficios={props.modal_beneficios}
                ></Producto>
              </li>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Grid;
